import ActionItemsSearch from "./ActionItemsSearch/ActionItemsSearch"

const ActionItems = () => {
  return (
    <>
    <ActionItemsSearch />
    </>
  )
}

export default ActionItems